var Shopify = Shopify || {};
Shopify.money_format = "${{amount_no_decimals}}";
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
};

let saving = false;

async function setFriendsFamilyCartAttributes() {
    const storageKey = 'parra_friends_family';

    let access = null;

    try {
        access = JSON.parse(localStorage.getItem(storageKey));
    } catch (error) {
        localStorage.removeItem(storageKey);
    }

    const now = Math.floor(Date.now() / 1000);

    const hasValidFriendsFamilyAccess =
        access &&
        access.event &&
        access.expires &&
        access.orderTag &&
        now <= Number(access.expires);

    let attributes;

    if (hasValidFriendsFamilyAccess) {
        attributes = {
            '_friends_family_event': access.event,
            '_friends_family_order_tag': access.orderTag
        };
    } else {
        // Remove expired/invalid local access.
        localStorage.removeItem(storageKey);

        // Explicitly mark this as a normal webshop cart.
        attributes = {
            '_friends_family_event': 'normal',
            '_friends_family_order_tag': ''
        };
    }

    await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            attributes: attributes
        })
    });
}

$('.add2cart .add2cart_inner > a').on('click', function(e) {
    e.preventDefault();
    if (!$(this).closest('.add2cart').hasClass('add2cart--soldout')) {
        if ($(this).closest('.add2cart').hasClass('add2cart--done')) {
            $(this).closest('.add2cart').removeClass('add2cart--done').find('.add2cart_inner > a').html('Add to cart');
        }
        $(this).closest('.add2cart').addClass('add2cart--open');
    }
});

$('.add2cart .size_guide h3').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.size_guide').toggleClass('size_guide--open');
});

$('.add2cart .add2cart_sizes ul li a, .add2cart a.add').on('click', function(e) {
    e.preventDefault();
    if (!saving && !$(this).hasClass('not_active')) {
        saving = true;

        $(this).addClass('loading');
        $(this).closest('ul').addClass('loading');

        const that      = $(this).closest('.add2cart');
        const formData = { 'items': [{'id': $(this).data('variantid'), 'quantity': 1 }] };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method  : 'POST',
            headers : {
                'Content-Type' : 'application/json'
            },
            body    : JSON.stringify(formData)
        }).then(async response => {
            if (response.ok)
            {
                await setFriendsFamilyCartAttributes();

                $.ajax({
                    url     : window.location.href,
                    success : function(res) {
                        $('.header .cart_btn font').html($(res).find('.cart .cart_inner').data('items'));
                        that.removeClass('add2cart--open').addClass('add2cart--done').find('.add2cart_inner > a').html('Item added to cart');
                        that.find('.size_guide').removeClass('size_guide--open');
                        $('.cart .cart_inner').html($(res).find('.cart .cart_inner').html());

                        that.find('ul, a').removeClass('loading');
                        saving = false;
                    },
                    error: function(e) {
                        console.log('e', e);
                        that.find('ul, a').removeClass('loading');
                        saving = false;
                    }
                });
            }
            else
            {
                const data = await response.json();

                let n = new Noty({
                    type        : "error",
                    text        : data.message || data.description || "Something went wrong",
                    layout      : "topRight",
                    progressBar : false,
                    buttons     : [
                        Noty.button('Close', 'button button--success', function () {
                            n.close();
                        })
                    ]
                });

                n.show();

                that.find('ul, a').removeClass('loading');
                saving = false;
            }
        }).catch((error) => {
            console.error('Error:', error);
            that.find('ul, a').removeClass('loading');
            saving = false;
        });
    }
})